import { defineMessages } from 'react-intl-next';

export const messages: {
	emptyStatePlaceholderLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStatePlaceholderLabel: {
		id: 'company-hub.company-hub-common.ui.empty-state.label-placeholder',
		defaultMessage: 'LABEL',
		description: 'Placeholder label that is displayed when no label is provided',
	},
});
